import { render, staticRenderFns } from "./nolaws.vue?vue&type=template&id=049cc710&scoped=true&"
import script from "./nolaws.vue?vue&type=script&lang=js&"
export * from "./nolaws.vue?vue&type=script&lang=js&"
import style0 from "./nolaws.vue?vue&type=style&index=0&lang=css&"
import style1 from "./nolaws.vue?vue&type=style&index=1&id=049cc710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cc710",
  null
  
)

export default component.exports